import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { FaThumbsUp } from 'react-icons/fa';
import { useAtom } from 'jotai';
import Modal from "./Modal";
import { Link } from "react-router-dom";
import config from "../Config";
import { isAuthAtom, authUserAtom, dataUserAtom } from '../Services/store/atoms';

const LikeButton = ({ feedId }) => {
    const modalRef = useRef(null);
    const [isLiked, setIsLiked] = useState(0);
    const [likeCount, setLikeCount] = useState(0);
    const [isAuth] = useAtom(isAuthAtom);
    const [authUser] = useAtom(authUserAtom);
    const [dataUser] = useAtom(dataUserAtom);

    const isAdmin = dataUser?.role === 'admin'; // Verifica si el usuario es admin

    const handleLike = async () => {
        if (isAdmin) {
            // Antes esto se resolvía solo con el atributo `disabled` del botón:
            // un botón disabled no dispara click en absoluto (ni siquiera
            // llega a este handler), así que para el admin era indistinguible
            // de un botón roto — sin ningún aviso de por qué no pasaba nada.
            modalRef.current.openModal(
                'info', 'Las cuentas de administrador no pueden dar like a las publicaciones.',
                <></>,
                <div className="bg-gray-50 px-4 py-3 sm:px-6">
                    <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-rose-500 text-base font-medium text-white hover:bg-rose-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500"
                        onClick={() => modalRef.current.closeModal()}
                    >
                        Entendido
                    </button>
                </div>
            );
            return;
        }

        if (!isAuth) {
            modalRef.current.openModal(
                'info', 'You need to log in to like this post.',
                <>
                </>,
                <div className="bg-gray-50 px-4 py-3 sm:px-6 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500"
                        onClick={() => modalRef.current.closeModal()}
                    >
                        Cancelar
                    </button>
                    <Link
                        to={`/login`}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-rose-500 text-base font-medium text-white hover:bg-rose-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500"
                    >
                        Log In
                    </Link>
                </div>
            );
            return;
        }

        try {
            const response = await axios.post(
                `${config.REACT_APP_BASE_URL}/api/v1/home/FeedPublic/like`, 
                {
                    feed_id: feedId
                }, 
                {
                    headers: {
                        Authorization: `Bearer ${authUser.token}`
                    }
                }
            );

            setIsLiked(response.data.liked);
            setLikeCount(response.data.likes_count);
        } catch (error) {
            console.error("Failed to like the post", error);
        }
    };

    const fetchLike = async () => {
        const url = (isAuth) ?
            `${config.REACT_APP_BASE_URL}/api/v1/home/FeedPublic/like/${feedId}` :
            `${config.REACT_APP_BASE_URL}/api/v1/home/FeedPublic/like/public/${feedId}`;
        
        try {
            const response = await axios.get(url);
    
            setIsLiked(response.data.liked);
            setLikeCount(response.data.likes_count);
        } catch (error) {
            console.error("Failed to like the post", error);
        }
    };
    
    useEffect(() => {
        fetchLike();
    }, []);

    return (
        <>
            {/* Cápsula con ícono y contador, como los botones de acción de iOS. */}
            <button
                className={`shrink-0 inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-[13px] font-medium transition-transform active:scale-95 ${isAdmin ? 'opacity-50 cursor-not-allowed' : ''}`}
                style={isLiked
                    ? { background: 'var(--ap-tint)', color: '#fff' }
                    : { background: 'var(--ap-fill)', color: 'var(--ap-label-2)' }}
                onClick={handleLike}
                aria-pressed={!!isLiked}
            >
                <FaThumbsUp className="text-sm" />
                <span>{likeCount}</span>
            </button>
            <Modal ref={modalRef} onClose={() => {/* Aquí puede ir alguna lógica adicional al cerrar el modal */ }} />
        </>
    );
};

export default LikeButton;